import { useState } from "react";
import { stockColor } from "../../helpers/merch-manager/helper";
import { EmptyState, LoadingSkeleton } from "./components";
import { usePaginate } from "../../hooks/usePaginate";

const Inventory = ({
  merch,
  selectedMerch,
  setSelectedMerch,
  isLoadingMerch,
  targetItemId,
}) => {
  const [search, setSearch] = useState("");
  const { showingItems, PaginateBtn } = usePaginate(merch, null);

  const filteredMerch = merch?.filter((m) =>
    m.item_name?.toLowerCase().includes(search.toLowerCase()),
  );

  return (
    <>
      <>
        {/* Search */}
        <div className="relative mb-3">
          <svg
            className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            />
          </svg>
          <input
            className="w-full pl-9 pr-3 py-2 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-sm text-gray-900 dark:text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primary transition-colors"
            placeholder="Search items…"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        {isLoadingMerch ? (
          <LoadingSkeleton />
        ) : filteredMerch.length === 0 ? (
          <EmptyState
            icon={
              <svg
                className="w-10 h-10"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1}
                  d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10"
                />
              </svg>
            }
            text={
              search
                ? "No items match your search"
                : "No merch items yet — add one above"
            }
          />
        ) : (
          <div className="space-y-2 pr-1">
            {filteredMerch.slice(0, showingItems).map((item) => {
              const isSelected = selectedMerch?.id === item.id;
              return (
                <button
                  id={item.id}
                  key={item.id}
                  onClick={() => {
                    setSelectedMerch(item);
                  }}
                  className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl border text-left transition-all ${
                    isSelected
                      ? "border-primary bg-primary/5 dark:bg-primary/10"
                      : "border-gray-100 dark:border-gray-700 bg-white dark:bg-gray-800 hover:border-gray-300 dark:hover:border-gray-600"
                  }`}
                >
                  {/* Thumbnail */}
                  {item.assets?.[0] ? (
                    <img
                      src={item.assets[0].url}
                      alt=""
                      className="w-10 h-10 rounded-lg object-cover shrink-0"
                    />
                  ) : (
                    <div className="w-10 h-10 rounded-lg bg-gray-100 dark:bg-gray-700 flex items-center justify-center shrink-0">
                      <svg
                        className="w-5 h-5 text-gray-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={1.5}
                          d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                        />
                      </svg>
                    </div>
                  )}

                  {/* Info */}
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-semibold text-gray-900 dark:text-white truncate">
                      {item.item_name}
                    </p>
                    <p className="text-xs text-gray-400 truncate">
                      {item.createdAt
                        ? item.createdAt.toDate().toLocaleDateString("en-AU", {
                            day: "numeric",
                            month: "short",
                            year: "numeric",
                          })
                        : "-"}
                    </p>
                  </div>

                  {/* Stock */}
                  <div className="text-right shrink-0">
                    <p
                      className={`text-sm font-bold ${stockColor(item.item_count)}`}
                    >
                      {item.item_count}
                    </p>
                    <p className="text-xs text-gray-400">in stock</p>
                  </div>
                </button>
              );
            })}
            <div className="flex justify-center">
              <PaginateBtn />
            </div>
          </div>
        )}
      </>
    </>
  );
};

export default Inventory;
